export enum AbuseFormValue {
  DEAF = 'deaf',
  HEARING = 'hearing',
  YES = 'yes',
  NO = 'no',
  CONNECTED = 'connected',
  DURING = 'during',
}
